import { Suspense, lazy } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import './App.css'

import ScrollToTop from './ScrollToTop.jsx'

// Lazy load components
const Beranda = lazy(() => import('./Pages/Beranda/Beranda.jsx'))
const Profil = lazy(() => import('./Pages/Profil/Profil.jsx'))
const DireksiKomisarisPage = lazy(() => import('./Pages/Direktur_komisaris/direksiPage.jsx'))
const ProdukDanBisnis = lazy(() => import('./Pages/Produk_bisnis/ProdukDanBisnis.jsx'))
const DagroJk = lazy(() => import('./components/bisnisWebsite/dagroJk/dagroJk.jsx'))
const DagroYk = lazy(() => import('./components/bisnisWebsite/dagroYk/dagroYk.jsx'))
const MinangSepakatBintaro = lazy(() => import('./components/bisnisWebsite/minangSepakatBintaro/minangSepakat.jsx'))
const BeritaAcara = lazy(() => import('./Pages/Berita_acara/BeritaAcara.jsx'))
const NewsDetailPage = lazy(() => import('./Pages/Berita_acara/NewsDetailPage.jsx'))
const Kontak = lazy(() => import('./Pages/Kontak/Kontak.jsx'))
const NotFound = lazy(() => import('./Pages/NotFound/NotFound.jsx'))

// Loading component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    fontSize: '1.2rem',
    color: '#333'
  }}>
    Loading...
  </div>
)

function App() {
  const location = useLocation()

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <Routes location={location}>
          <Route path="/" element={<Beranda />} />
          <Route path="/profil-dan-sejarah-singkat" element={<Profil />} />
          <Route path="/page/direksi-dan-komisaris" element={<DireksiKomisarisPage />} />
          <Route path="/bisnis-pt-nna" element={<ProdukDanBisnis />} />
          <Route path="/bisnis-pt-nna/dagrofinecoffee" element={<DagroJk />} />
          <Route path="/bisnis-pt-nna/dagrofinecoffeeyk" element={<DagroYk />} />
          <Route path="/bisnis-pt-nna/minangsepakatbintaro" element={<MinangSepakatBintaro />} />
          <Route path="/berita-dan-acara" element={<BeritaAcara />} />
          <Route path="/berita-dan-acara/:slug" element={<NewsDetailPage />} />
          <Route path="/kontak" element={<Kontak />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </>
  )
}

export default App
